export class SortingModel {
    fieldName: string;
    sortingType: string = "NA";

    constructor() {
    }

    equals(sortingModel: SortingModel) {
        return this.fieldName == sortingModel.fieldName;
    }

    changeStatus(): boolean {
        
        this.sortingType = this.sortingType == 'asc' ? 'desc' : this.sortingType == 'desc' ? 'NA' : this.sortingType == 'NA' ? 'asc' : '';
        return this.sortingType != 'NA';
    }
}

export class SortingCurrentStatus {
    idStatus: string = "NA";
    orderNoStatus: string = "NA";
    tenantStatus: string = "NA";
    stationStatus: string = "NA";
    cityStatus: string = "NA";
    terminalStatus: string = "NA";
    supplierStatus: string = "NA";
    statusStatus: string = "NA";
    dateStatus: string = "NA";
    etaStatus: string = "NA";
    bolStatus: string = "NA";
    totalStatus: string = "NA";
    tacStatus: string = "NA";
    invoiceStatus: string = "NA";
    dealerStatus: string = "NA";
    addressStatus: string = "NA";
    stateStatus: string = "NA";
    billtypeStatus: string = "NA";
}